import { getImage } from '@utils/imageHelper';
import { useEffect } from 'react';
import pushRoute from '@utils/pushRoute';
import { ThankYouCardWrapper } from './styles';
import {
  Confetti,
  ImageContainer,
  PulsatingGreenTick,
  ThankyouHeader,
  ThankyouSubHeader,
  ThankyouWrapper
} from '../EnquiryPage/styles';

const FormSubmittedCard = ({
  detailedText = 'Your details have been captured. Redirecting you to home page'
}) => {
  useEffect(() => {
    const timeoutID = setTimeout(() => {
      pushRoute('/', '/');
    }, 3000);
    return () => {
      clearTimeout(timeoutID);
    };
  }, []);
  return (
    <ThankYouCardWrapper>
      <ThankyouWrapper>
        <ImageContainer>
          <Confetti
            alt="confetti"
            src={getImage('bundles/offlineConfetti.gif')}
          />
          <PulsatingGreenTick
            size="65px"
            color="var(--color-i-green)"
            viewBox="4 4 16 16"
          />
        </ImageContainer>
        <ThankyouHeader>Thank you</ThankyouHeader>
        <ThankyouSubHeader>{detailedText}</ThankyouSubHeader>
      </ThankyouWrapper>
    </ThankYouCardWrapper>
  );
};

export default FormSubmittedCard;
